'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _styles = require('../../common/styles');

exports.default = {
	body: {
		display: 'table-row-group',
		width: '100%',
		fontSize: '13px'
	},

	row: function row(_ref) {
		var hover = _ref.hover;

		var rowStyles = {};

		if (hover) {
			rowStyles[':hover'] = {
				backgroundColor: _styles.colors.baseColors.offWhite
			};
		}
		return rowStyles;
	}
};


// WEBPACK FOOTER //
// ./~/@workmarket/front-end-components/dist/WMTableBody/styles/index.js